import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative box-border min-h-[250px] w-full max-w-none overflow-hidden rounded-2xl border border-[#E5E7EB] bg-[#F5F6F8] shadow-[0_1px_3px_rgba(0,0,0,0.1),0_1px_2px_-1px_rgba(0,0,0,0.1)] sm:max-w-[325px]" }
const _hoisted_2 = { class: "flex flex-col items-start gap-3 px-5 pb-5 pt-4" }
const _hoisted_3 = { class: "flex h-8 w-8 items-center justify-center rounded-[14px] bg-white shadow-[0_0_0_1px_#E5E5E5,0_1px_3px_rgba(0,0,0,0.1),0_1px_2px_-1px_rgba(0,0,0,0.1)]" }
const _hoisted_4 = { class: "w-full space-y-2" }
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = { class: "text-sm font-bold uppercase tracking-[0.7px] text-[#242B59]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("span", {
      class: "absolute bottom-0 left-0 top-0 w-1.5",
      style: _normalizeStyle({ backgroundColor: $setup.severity.color })
    }, null, 4 /* STYLE */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode($setup["LightBulbIcon"], {
          class: "h-4 w-4 text-[#242B59]",
          "aria-hidden": "true"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('aura.cards.insight.title')), 1 /* TEXT */),
          _createElementVNode("span", {
            class: "rounded-full px-2 py-0.5 text-[11px] font-bold uppercase tracking-[0.55px]",
            style: _normalizeStyle({ backgroundColor: $setup.severity.color, color: $setup.severity.text })
          }, _toDisplayString($setup.severity.label), 5 /* TEXT, STYLE */)
        ]),
        _createVNode($setup["AuraRichText"], {
          class: "text-sm font-medium leading-[23px] text-[#626468]",
          text: $props.insight.text
        }, null, 8 /* PROPS */, ["text"])
      ])
    ])
  ]))
}